export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_06.756a1ddb.jpg";